'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _merge = require('lodash/object/merge');

var _merge2 = _interopRequireDefault(_merge);

var _flattenMessages = require('common/utils/flatten-messages');

var _flattenMessages2 = _interopRequireDefault(_flattenMessages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getDefaultMessages = function getDefaultMessages() {
    return (0, _flattenMessages2['default'])((0, _merge2['default'])(require('signer/translations/en-US.json'), require('ui/signature-modal/translations/en-US.json')));
};

var makeComponentIntl = function makeComponentIntl(component) {
    var InjectedComponent = (0, _reactIntl.injectIntl)(component);

    // Needs to be a class because refs are added by React Intl

    var IntlComponent = function (_React$Component) {
        _inherits(IntlComponent, _React$Component);

        function IntlComponent() {
            _classCallCheck(this, IntlComponent);

            return _possibleConstructorReturn(this, (IntlComponent.__proto__ || Object.getPrototypeOf(IntlComponent)).apply(this, arguments));
        }

        _createClass(IntlComponent, [{
            key: 'render',
            value: function render() {
                var intlMessages = this.props.intl ? (0, _flattenMessages2['default'])(this.props.intl.messages) : null;
                var messages = this.props.messages || intlMessages || getDefaultMessages();

                return _react2['default'].createElement(
                    _reactIntl.IntlProvider,
                    { locale: 'en-US', messages: messages },
                    _react2['default'].createElement(InjectedComponent, this.props)
                );
            }
        }]);

        return IntlComponent;
    }(_react2['default'].Component);

    return IntlComponent;
};

exports['default'] = makeComponentIntl;

module.exports = makeComponentIntl;


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/utils/make-component-intl.jsx
 ** module id = 734
 ** module chunks = 0 1
 **/